import { Component, input } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import {
  FormFieldComponent,
  InputComponent,
  NumericInputComponent,
  TextareaComponent,
} from '@core/user-interface-legacy';
import type { RespondFormWrapperConfig } from '@tellent-ask-hr/dynamic-forms-types';

import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

export interface RespondTextConfig extends RespondFormWrapperConfig {
  placeholder: string;
  kind: 'single-line' | 'multiline' | 'number' | 'link';
}

@Component({
  selector: 'input-text-respond',
  imports: [
    RespondFormWrapperComponent,
    ReactiveFormsModule,
    InputComponent,
    TextareaComponent,
    NumericInputComponent,
    FormFieldComponent,
  ],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      <rt-form-field>
        @switch (respondConfig().kind) {
          @case ('single-line') {
            <rt-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
            />
          }
          @case ('multiline') {
            <rt-textarea
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
            />
          }
          @case ('number') {
            <rt-numeric-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
            />
          }
          @case ('link') {
            <rt-input
              [readOnly]="!!respondConfig().disabled"
              [formControl]="respondForm().controls.value"
              [placeholder]="respondConfig().placeholder"
            />
          }
        }
      </rt-form-field>
    </respond-form-wrapper>
  `,
})
export class RespondTextComponent {
  public respondConfig = input.required<RespondTextConfig>();
  public respondForm = input.required<
    FormGroup<{
      value: FormControl<string | null>;
    }>
  >();
}
